import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../../lib/constants";
import { useAuth } from "../../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/admin");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser({ ...data });
        window.history.replaceState(null, "", "/admin/dashboard");
        navigate("/admin/dashboard", { state: { user: data } });
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/admin"), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-gold animate-spin mx-auto" />
        <p className="mt-4 text-zinc-400">{error ? "Falha na autenticação. Redirecionando..." : "Autenticando..."}</p>
      </div>
    </div>
  );
}
